import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import '@splidejs/splide/css/core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ChevronIcon } from "../assets/images/icons/ic-chevron.svg";
import { Each } from "../common/Each";
import Button from "./Button";
import LessonCard from "./cards/LessonCard";
import styles from "./LessonsCarousel.module.css";
import Skeleton from './Skeleton';

const LessonsCarousel = ({ lessons, loading }) => {

    const { t } = useTranslation()
    const navigate = useNavigate()
    const splideRef = useRef(null)
    const [splideIndex, setSplideIndex] = useState(0)

    useEffect(() => {
        if (splideRef && splideRef.current) {
            splideRef.current.splide.on('move', () => {
                setSplideIndex(splideRef.current.splide.index)
            })
        }
    }, [splideRef, splideRef.current])

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.title}>
                    {t('courses.nextLessons').toUpperCase()}
                </div>


                <div className={styles.arrows}>
                    <button
                        disabled={splideIndex === 0}
                        className={`${styles.arrowButton} ${styles.left}`}
                        onClick={() => {
                            if (splideRef && splideRef.current) {
                                // let index = splideRef.current.splide.index
                                splideRef.current.splide.go('<')
                                setSplideIndex(splideRef.current.splide.index)
                            }
                        }}
                    >
                        <ChevronIcon />
                    </button>
                    <button
                        disabled={splideIndex >= lessons.length - 1}
                        className={`${styles.arrowButton} ${styles.right}`}
                        onClick={() => {
                            if (splideRef && splideRef.current) {
                                // let index = splideRef.current.splide.index
                                splideRef.current.splide.go('>')
                                setSplideIndex(splideRef.current.splide.index)
                            }
                        }}>
                        <ChevronIcon />
                    </button>
                </div>

            </div>
            <div className={styles.content}>
                <Splide
                    id={styles.lessonCarousel}
                    ref={splideRef}
                    options={
                        {
                            arrows: false,
                            pagination: true,
                            perPage: 4,
                            perMove: 4,
                            gap: '1rem',
                            breakpoints: {
                                1440: {
                                    perPage: 3,
                                    perMove: 3,
                                },
                                1120: {
                                    perPage: 2,
                                    perMove: 2,
                                },
                                830: {
                                    perPage: 1,
                                    perMove: 1,
                                },
                                768: {
                                    perPage: 2,
                                    perMove: 2,
                                },
                                540: {
                                    perPage: 1,
                                    perMove: 1,
                                }
                            }
                        }
                    }
                >
                    {lessons.length > 0 && !loading &&
                        <Each of={lessons} render={(lesson) => {
                            return (
                                <SplideSlide className={styles.lessonSlide}>
                                    <LessonCard lesson={lesson} />
                                </SplideSlide>
                            )
                        }} />
                    }
                    {loading &&
                        <Each of={[1, 2, 3, 4]} render={() => {
                            return (
                                <SplideSlide className={styles.lessonSlide}>
                                    <Skeleton height={280} width={'100%'} borderRadius={'0.5rem'} />
                                </SplideSlide>
                            )
                        }} />
                    }
                    {lessons.length === 0 && !loading &&
                        <div className={styles.noLessons}>
                            <div>{t('courses.noLessons')}</div>
                        </div>
                    }
                </Splide>

            </div>
        </div>
    )

}

export default LessonsCarousel
